module.exports = __webpack_public_path__ + "static/icons/icon-loader-0aa44ba640436278e3bf3203dc7d80d2.svg";